import { mergeMap, switchMap } from 'rxjs/internal/operators';
import { Component } from '@angular/core';
import { DataStateService } from '../core/services/data-state.service';
import { BestellingDorpelDto, BestellingDto, BestellingSluitpotDto, BewerkingUtils } from '../shared/api-models/models';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from '../core/services/backend.service';
import { BaseComponent } from '../shared/base.component';
import { Observable, from, of } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { UiStateService } from '../core/services/ui-state-service';
import { CleanupService } from '../core/services/cleanup.service';
import { Location } from '@angular/common';

@Component({
  templateUrl: './overzicht.component.html',
  styleUrls: ['./overzicht.component.scss']
})
export class OverzichtComponent extends BaseComponent {

  public model: BestellingDto;
  public logoUrl: string;
  public customClass: string;

  constructor(private dataService: DataStateService, private router: Router,
    private _location: Location,
    private uiStateService: UiStateService,
    private backendService: BackendService,
    private spinner: NgxSpinnerService,
    private cleanupService: CleanupService,
    private activatedRoute: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.model = this.dataService.getModel();
    this.logoUrl = this.uiStateService.logoUrl;
  }

  public onGoBackButtonClicked() {
    this._location.back();
  }

  public onDorpelConfirmButtonClicked() {
    this.spinner.show();
    this.postRequest().subscribe(r => {
      this.cleanupService.cleanup();
      setTimeout(() => {
        this.spinner.hide();
        this.router.navigate(['redirect'], { 
          relativeTo: this.activatedRoute.parent,
          queryParams: { orderNo: r.orderNo, requestId: r.requestId }
        });
      }, 500);
    }, err => {
      alert('There was an error processing your request! Please try again');
      this.spinner.hide();
      console.error(err);
    });
  }

  public getNeutName(positie: string): string {
    switch (positie) {
      case 'Links':
        return 'Linkerneut';
      case 'Tussen':
        return 'Middenneut';
      case 'Rechts':
        return 'Rechterneut';
    }
  }

  public getMaatZLabel(regularPosition: number, dorpelCode?: string, schema?: string): string {
    let isSliding = dorpelCode.toLowerCase().indexOf('hs') !== -1;

    if (!isSliding) {
      return `Vak ${regularPosition}`;
    }

    if (!schema || schema === 'AL' || schema === 'AR') {
      return "Vak 2";
    }

    if (schema === 'C+G') {
      return "Vak 3";
    }

    return "Vak 4";
  }


  public getConcatenatedBewerkingen(dorpel: BestellingDorpelDto): string {
    return dorpel.bewerkingen.map(b => {
      let hasCustomDimensions: boolean = !!b.customDepth || !!b.customLength || !!b.customOffset;
      let hasCustomOrientation: boolean = !!b.orientatie;
      let hasNeutCutOption: boolean = b.cutNeut !== null;
      let isKloostersponning: boolean = BewerkingUtils.isKloostersponning(b.description);
      let isRenovatiesponning: boolean = BewerkingUtils.isRenovatiesponning(b.description);
      let lengteLabel = isKloostersponning ? "(C) Lengte" : (isRenovatiesponning ? "(A) Lengte" : "");

      if (hasCustomOrientation) {
        let orientatieLabel = b.orientatie == "naarBuiten" ? "Naar Buiten" : (b.orientatie == "naarBinnen" ? "Naar Binnen": "");
        return b.description + (b.orientatie ? ` - Oriëntatie: ${orientatieLabel}` : "") + (hasNeutCutOption ? ` - Neut laten doorlopen in verstek: ${b.cutNeut ? "Ja" : "Nee"}` : "");
      }

      if (hasCustomDimensions) {
        return b.description + (b.customOffset ? ` - (A) Uit de dagkant: ${b.customOffset}mm` : "") + (b.customDepth ? ` - (B) Diepte: ${b.customDepth}mm` : "") + (b.customLength ? ` - ${lengteLabel}: ${b.customLength}mm` : "");
      }

      return b.description;
    }).join(', ');
  }

  public getSluitpotDimensions(sluitpot: BestellingSluitpotDto): string {
    let dimensions = "";

    if (sluitpot.maat) {
      dimensions += ` - ${sluitpot.maat}MM`
    }

    if (sluitpot.maat2) {
      dimensions += ` - ${sluitpot.maat2}MM`
    }

    return dimensions
  }

  private prefilledOrderFlowCleanup() {
    this.model.prefilledOrderformFile = null;
    this.uiStateService.fromPrefilledOrder = false;
  }

  private postRequest(): Observable<any> {
    const formData = new FormData();

    formData.append('json', JSON.stringify(this.model));

    if (this.uiStateService.fromPrefilledOrder) {
      this.prefilledOrderFlowCleanup();
    }

    return this.backendService.getOrderNo()
      .pipe(switchMap((orderNo: string) => this.uploadAttachments(this.model, orderNo)))
      .pipe(switchMap((orderNo: string) => this.backendService.postForm(formData, orderNo)));
  }

  private uploadAttachments(model: BestellingDto, orderno: string): Observable<any> {
    if (!model.files || model.files.length === 0) {
      return of(orderno);
    }

    //return forkJoin([model.files.map(f => this.uploadAttachmentFile(f, orderno))]);
    return from(model.files)
      .pipe(mergeMap(file => this.uploadAttachmentFile(file, orderno)));
  }

  private uploadAttachmentFile(file: any, orderno): Observable<any> {
    return this.backendService.uploadAttachment(file, orderno);
  }
}



